import { timeFormat, timeParse } from 'd3-time-format';
import { line, curveMonotoneX } from 'd3-shape';
import { extent, max, min } from 'd3-array';
import { linearAxis, timeAxis } from '../../../factory/axes';
import { ordinalScale } from '../../../factory/scales';

import raw from './data/data.json';
import { teal } from './utils/colors';

export default function (props) {
  const { initialWidth, initialHeight, isMobile } = props;

  const margins = {
    top: 10,
    right: isMobile ? 35 : 35,
    bottom: 20,
    left: 35,
  };

  const width = initialWidth - margins.right - margins.left;
  const height = initialHeight - margins.top - margins.bottom;
  const parser = timeParse('%Y-%m-%d'); // https://github.com/d3/d3-time-format;
  const keys = Object.keys(raw[0]).slice(1);

  const data = keys.map(id => ({ id, values: raw.map(d => ({ date: parser(d.date), value: +d[id] })) }));

  const maxValue = max(data, d => max(d.values, v => v.value));
  const minValue = min(data, d => min(d.values, v => v.value));

  const xAxisConfig = {
    orientation: 'bottom',
    domain: extent(raw, d => parser(d.date)),
    range: [0, width],
    nice: false,
  };

  const yAxisConfig = {
    orientation: 'left',
    domain: [-1, 5],
    range: [height, 0],
    nice: false,
  };

  const { axis: xAxis, scale: x } = timeAxis(xAxisConfig);
  const { axis: yAxis, scale: y } = linearAxis(yAxisConfig);

  const colorRange = ['#005a54', '#99f1e9'];
  const color = ordinalScale({ range: colorRange, domain: keys });

  const path = line()
    .curve(curveMonotoneX)
    .x(d => x(d.date))
    .y(d => y(d.value));

  return {
    color,
    data,
    fmtYearAbbrev: timeFormat('%y'),
    fmtYearFull: timeFormat('%Y'),
    fmtMonth: timeFormat('%B'),
    initialWidth,
    initialHeight,
    margins,
    height,
    path,
    width,
    x,
    xAxis,
    y,
    yAxis,
    parser,
  };
}
